<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-logo">
            <span class="logo-text">弥央大学</span>
            <span class="logo-subtitle">MIO UNIVERSITY</span>
          </div>
          <p class="footer-description">
            这是一个以学习与创作为目的的个人项目站点，并非真实高校或官方机构。
          </p>
        </div>
        
        <div class="footer-section">
          <h4>快速链接</h4>
          <ul class="footer-links">
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/links">友情链接</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>联系我</h4>
          <div class="social-links">
            <a href="https://github.com/AmamiyaHotaru" target="_blank" rel="noopener noreferrer" class="social-link" title="GitHub"><i class="fab fa-github"></i></a>
            <a href="https://space.bilibili.com/3095298" target="_blank" rel="noopener noreferrer" class="social-link" title="哔哩哔哩"><i class="fab fa-bilibili"></i></a>
            <a href="https://www.eunie.online/" target="_blank" rel="noopener noreferrer" class="social-link" title="个人博客"><i class="fas fa-blog"></i></a>
            <a href="https://steamcommunity.com/id/amamiyahotaru/" target="_blank" rel="noopener noreferrer" class="social-link" title="Steam"><i class="fab fa-steam"></i></a>
          </div>
          <div class="contact-info">
            <p><i class="fas fa-envelope"></i> eunie@eunie.online</p>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
  <p>&copy; {{ currentYear }} 弥央大学（个人项目）. All rights reserved.</p>
        <p class="easter-egg">✨ 对我而言...是「只剩」两个月啊 ✨</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
  color: white;
  padding: 3rem 0 1rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section {
  h4 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #90cdf4;
  }
}

.footer-logo {
  margin-bottom: 1rem;
  
  .logo-text {
    font-family: 'Orbitron', sans-serif;
    font-size: 2rem;
    font-weight: 900;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: block;
  }
  
  .logo-subtitle {
    font-size: 0.8rem;
    color: #a0aec0;
    letter-spacing: 2px;
  }
}

.footer-description {
  color: #cbd5e0;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.footer-links {
  list-style: none;
  
  li {
    margin-bottom: 0.5rem;
    
    a {
      color: #e2e8f0;
      text-decoration: none;
      transition: color 0.3s ease;
      
      &:hover {
        color: #90cdf4;
      }
    }
  }
}

.social-links {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.social-link {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-3px) scale(1.1);
  }
  
  // 为哔哩哔哩使用自定义图标（如果 Font Awesome 没有的话）
  .fa-bilibili::before {
    content: "B";
    font-family: inherit;
    font-weight: bold;
    font-style: normal;
  }
}

.contact-info {
  p {
    color: #cbd5e0;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    
    i {
      margin-right: 0.5rem;
      color: #90cdf4;
    }
  }
}

.footer-bottom {
  border-top: 1px solid #4a5568;
  padding-top: 1rem;
  text-align: center;
  color: #a0aec0;
  
  p {
    margin-bottom: 0.5rem;
  }
  
  .easter-egg {
    font-size: 0.9rem;
    opacity: 0.7;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .social-links {
    justify-content: center;
  }
}
</style>
